import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CrudService } from '../shared/grid/crud.service';
import { TenantRisk } from '../models/tenantRisk.model';

@Injectable({
    providedIn: 'root'
})
export class TenantRiskService extends CrudService<TenantRisk> {

    constructor(http: HttpClient) {
        super('TenantRisk', http);
    }

    /**
     * Reads the calling tenant's row. The server resolves the tenant from the JWT claim, so no id is
     * sent — this is a REST route, not a `{controllerName}/{Method}` one, and does not compose from
     * `CrudService`'s controllerName convention.
     */
    getCurrent(): Observable<TenantRisk> {
        return this.http.get<TenantRisk>(this.getApiUrl('tenant-risks/current'));
    }
}
